import { render } from "./PurchaseRequestDetailsModal.vue?vue&type=template&id=02d0a8a0&scoped=true"
import script from "./PurchaseRequestDetailsModal.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestDetailsModal.vue?vue&type=script&lang=js"

import "./PurchaseRequestDetailsModal.vue?vue&type=style&index=0&id=02d0a8a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d0a8a0"]])

export default __exports__